import {
  QUERY_PARAM_PAYMENT_INTENT,
  QUERY_PARAM_REDIRECTION_STATUS,
  QUERY_PARAM_SETUP_INTENT,
  REDIRECTION_STATUS_SUCCEEDED,
} from "../constants";

const urlMatchesSuccessfulSetupIntent = (params: URLSearchParams): boolean => {
  return (
    params.get(QUERY_PARAM_SETUP_INTENT) !== null &&
    params.get(QUERY_PARAM_REDIRECTION_STATUS) === REDIRECTION_STATUS_SUCCEEDED
  );
};

const urlMatchesSuccessfulPaymentIntent = (
  params: URLSearchParams
): boolean => {
  return (
    params.get(QUERY_PARAM_PAYMENT_INTENT) !== null &&
    params.get(QUERY_PARAM_REDIRECTION_STATUS) === REDIRECTION_STATUS_SUCCEEDED
  );
};

export { urlMatchesSuccessfulSetupIntent, urlMatchesSuccessfulPaymentIntent };
